const EXCLUDED = "*";

export const set = (tableName, data, row, value) => {
	const indicator = value ? EXCLUDED : "";
	data.setCell(tableName, row.key, 0, indicator, () => indicator);
};

const findChildren = (rows, row) =>
	row.list[4].map((ck) => rows.find(({ key }) => key === ck));

// переключает ветку элементов
export const toggleTree = (tableName, data, rows, row, value) => {
	set(tableName, data, row, value);
	for (const cr of findChildren(rows, row))
		toggleTree(tableName, data, rows, cr, value);
};

// обновляет строки всех предков
const backprop = (tableName, data, rows, row) => {
	const parent = rows.find(({ list }) => list[4].includes(row.key));
	if (!parent) return;
	const children = findChildren(rows, parent);
	const nf = children.every(({ list }) => list[0] === EXCLUDED);
	set(tableName, data, parent, nf);
	backprop(tableName, data, rows, parent, nf);
};

// обрабатывает добавление и снятие флага выбора с учетом структуры
export const toggle = (tableName, data, rows, row) => {
	const value = row.list[0] !== EXCLUDED;
	toggleTree(tableName, data, rows, row, value);
	backprop(tableName, data, rows, row);
};

export const setAll = (tableName, data, value) => {
	for (const row of data.curData.values.table[tableName].list)
		set(tableName, data, row, value);
};
